import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Switch } from '@mui/material';
import Toggle from '../../../components/common/toggleButton';

export interface AutoStackProps {
  value: IAutoStackValueProps;
  onChange: (_value: IAutoStackValueProps) => void;
  title: string;
}

export interface IAutoStackValueProps {
  autoStack: {
    [key: string]: boolean;
    mobile: boolean;
    tablet: boolean;
    desktop: boolean;
  };
  deviceType: string;
}

const AutoStack: React.FC<AutoStackProps> = ({ title, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={() => setIsOpen(!isOpen)}>
        <h3>{title}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="flex flex-col gap-4 mt-3  border border-gray-300 rounded p-2 w-full">
          <Toggle<IAutoStackValueProps>
            value={value}
            onChange={newValue => onChange({ ...value, ...newValue })}
            heading={{ label: 'Device', value: 'device' }}
            options={[
              { label: 'Tablet', value: 'tablet' },
              { label: 'Mobile', value: 'mobile' },
              { label: 'Desktop', value: 'desktop' },
            ]}
            propName="deviceType"
          />
          <div className="flex items-center justify-between">
            <label>Auto stack</label>
            <Switch
              checked={value?.autoStack?.[value?.deviceType]}
              onChange={e => {
                onChange({
                  ...value,
                  autoStack: {
                    ...value?.autoStack,
                    [value?.deviceType]: e.target.checked,
                  },
                });
              }}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AutoStack;
